import styled from "styled-components";

export const KnowledgePageContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 16px;
`;

export const KnowledgePageHeaderWrapper = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	gap:24px;
`;

export const KnowledgePageHeader = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	align-items: stretch;
`;

export const KnowledgePageFilterWrapper = styled.div`
	display: flex;
`;

export const KnowledgeInfoWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  align-self: flex-start;
`
export const KnowledgeActionWrapper = styled.div`
	display: flex;
	align-self: flex-start;
  position: relative;

  & > .add-menu {
      position: absolute;
      top: 100%;
      right: 0;
      z-index: 1000;
  }
`
